import { createSelector } from "reselect"
import { get } from "lodash"
import { LOADING, ERROR, OK, UNKNOWN } from "helpers/data-statuses"

const getStatus1 = state => get(state, "global.data.comparePerformancePositionSet1.status")
const getStatus2 = state => get(state, "global.data.comparePerformancePositionSet2.status")
const getStatus3 = state => get(state, "global.data.comparePerformancePositionSet3.status")
const getStatus4 = state => get(state, "global.data.comparePerformancePositionSet4.status")

export const getStatus = createSelector(
  [getStatus1, getStatus2, getStatus3, getStatus4],
  (...statuses) => statuses.reduce((previous, current) => {
    // if any is in error, return error
    if (previous === ERROR || current === ERROR) {
      return ERROR
      // if none is in error but any is loading or unknown, return loading
    } else if (previous === UNKNOWN || current === UNKNOWN
      || previous === LOADING || current === LOADING) {
      return LOADING
    } else {
      return OK
    }
  }, OK),
)
